import { useEffect } from 'react'
import { Grid, Stack, Tooltip } from '@mui/material'
import DateHelper, { DATE_FORMAT_MMDDYYYYHHMMSS } from 'common/Date.helpers'
import { MessageRead } from 'common/types/kraken-core/Message'
import ClipboardLabel from 'atoms/ClipboardLabel'
import { useMessagesDashboardViewContext } from '../MessagesDashboardViewContext'
import PartnershipTag from 'atoms/PartnershipTag/PartnershipTag'
import MessageStatusTag from '../common/MessageStatusTag'
import { isEmpty, capitalize } from 'lodash'
import { useMessagesDashboardContext } from '../MessageDahsboardContext'
import WrappedFieldLabel from 'atoms/FieldLabel/FieldLabel'
import InstallationTag from 'atoms/InstallationTag/InstallationTag'
import { Tag } from '@loadsmart/loadsmart-ui'
export interface MessageSummaryProps {
  message: MessageRead
}

const STATUS_TAGS_COUNT = 3

function MessageSummary({ message }: MessageSummaryProps) {
  const dashboardContext = useMessagesDashboardContext()
  const context = useMessagesDashboardViewContext()

  const partyReference = String(message.party_reference ?? '')
  const counterpartyReference = String(message.counterparty_reference ?? '')
  const createdAt = String(message.created_at ?? '')
  const updatedAt = String(message.updated_at ?? '')
  const bodyContentType = String(message.content_type ?? '')

  useEffect(() => {
    context.selectMessages([message])
  }, [])

  const DeliveredTag = () => {
    if (message.delivered) {
      return (
        <Tag size="large" variant="accent">
          Delivered
        </Tag>
      )
    }

    return (
      <Tag size="large" variant="danger">
        <span className="text-nowrap">Not Delivered</span>
      </Tag>
    )
  }

  const getTagDescription = (tagName: string) => {
    return (
      dashboardContext.messageDetails.messageStatusTags.find(to => to.tag === tagName)
        ?.description || ''
    )
  }

  return (
    <Stack>
      <Grid container className="pb-4" direction="row" spacing={0}>
        <Grid container direction="row" className="pb-4" spacing={2}>
          <Grid item xs={4} data-testid="message-summary-content-type">
            <WrappedFieldLabel>Content Type</WrappedFieldLabel>
            <ClipboardLabel value={String(bodyContentType)} />
          </Grid>
          <Grid item xs={4}>
            <WrappedFieldLabel>Created at.</WrappedFieldLabel>
            <ClipboardLabel
              value={String(DateHelper(createdAt)?.format(DATE_FORMAT_MMDDYYYYHHMMSS))}
            />
          </Grid>
          <Grid item xs={4}>
            <WrappedFieldLabel>Updated at.</WrappedFieldLabel>
            <ClipboardLabel
              value={String(DateHelper(updatedAt)?.format(DATE_FORMAT_MMDDYYYYHHMMSS))}
            />
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={2} alignItems={'end'}>
          <Grid item xs={4} data-testid="message-summary-party">
            <WrappedFieldLabel>Party Reference</WrappedFieldLabel>
            <ClipboardLabel value={partyReference} />
          </Grid>
          <Grid item xs={4} data-testid="message-summary-counterparty">
            <WrappedFieldLabel>Counter Party Reference</WrappedFieldLabel>
            <ClipboardLabel value={counterpartyReference} />
          </Grid>
          <Grid item>
            <InstallationTag installationId={message.headers?.['Installation-ID'] ?? ''} />
          </Grid>
          <Grid item>
            {message.partnership ? <PartnershipTag parntershipId={message.partnership} /> : null}
          </Grid>
        </Grid>
      </Grid>

      <Grid container alignItems="end">
        <Grid item>
          <Grid
            container
            spacing={1}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'start',
              alignItems: 'center',
              paddingTop: 2,
            }}
          >
            <Grid item>
              <DeliveredTag />
            </Grid>

            {message.status && !isEmpty(message.status) ? (
              <Grid item>
                <MessageStatusTag status={message.status} size="large" />
              </Grid>
            ) : null}

            {message?.status_tags?.slice(0, STATUS_TAGS_COUNT - 1).map(st => {
              return (
                <Grid item key={st}>
                  <Tooltip key={st} title={getTagDescription(st)}>
                    <div>
                      <Tag key={st} size="large">
                        {capitalize(st)}
                      </Tag>
                    </div>
                  </Tooltip>
                </Grid>
              )
            })}
          </Grid>
        </Grid>
      </Grid>
    </Stack>
  )
}

export default MessageSummary
